import { render, staticRenderFns } from "./CbsNews.vue?vue&type=template&id=f5630a16&"
import script from "./CbsNews.vue?vue&type=script&lang=js&"
export * from "./CbsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports